/** Bright Acorns drag slop (6 CSS px squared) — a gesture number, not a spacing token. */
export const DRAG_SLOP = 36;
export const EAT_HOLD_MS = 1200;
export const DOCK_POS = { x: 50, y: 80 };

export type PlaceFoodItem = { code: string; name: string };

export function prefersFinePointer(): boolean {
  return typeof window.matchMedia === 'function'
    && (window.matchMedia('(pointer: fine)').matches
      || window.matchMedia('(hover: hover)').matches);
}

export function isMouseLike(e: { pointerType: string }): boolean {
  return e.pointerType === 'mouse' || e.pointerType === 'pen';
}

export function isFoodHintTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest('.habitat-food-hint'));
}

export function isFoodGhostTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest('.habitat-food-ghost'));
}
